// extracted by mini-css-extract-plugin
export default {"supplementRow":"BRPXjYh6KbFlhw0KMihl"};